import React from "react";

interface PaymentMethodSelectionProps {
  planKey: string;
  planName: string;
  onSelectCardPayment: () => void;
  onSelectCmsPayment: () => void;
  onBack: () => void;
}

export default function PaymentMethodSelection({
  planKey,
  planName,
  onSelectCardPayment,
  onSelectCmsPayment,
  onBack
}: PaymentMethodSelectionProps) {
  return (
    <div className="flex justify-center items-center min-h-screen bg-gray-50">
      <div className="w-full max-w-md bg-white rounded-lg shadow-lg">
        <div className="p-6 border-b">
          <div className="flex items-center justify-between mb-4">
            <button
              onClick={onBack}
              className="btn btn-ghost btn-sm"
            >
              ← 뒤로가기
            </button>
          </div>
          <h2 className="text-xl font-bold text-center text-gray-800">결제 방법 선택</h2>
          <p className="text-sm text-center text-gray-500 mt-2">
            {planName} 가입을 위한 결제 방법을 선택해 주세요.
          </p>
        </div>

        <div className="p-6 space-y-4">
          {/* 카드 결제 버튼 */}
          <div className="relative">
            <button
              onClick={onSelectCardPayment}
              className="w-full p-6 border-2 border-blue-200 rounded-lg hover:border-blue-400 hover:bg-blue-50 transition-all duration-200"
            >
              <div className="flex items-center justify-center space-x-3">
                <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center">
                  <svg className="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
                  </svg>
                </div>
                <div className="text-left">
                  <div className="font-semibold text-gray-800">카드 결제로 가입하기</div>
                  <div className="text-sm text-gray-500">신용카드/체크카드 온라인 결제</div>
                </div>
              </div>
            </button>
            <div className="absolute -top-2 -right-2 bg-blue-600 text-white text-xs px-2 py-1 rounded-full font-medium">
              추천
            </div>
          </div>

          {/* 효성CMS 버튼 */}
          <button
            onClick={onSelectCmsPayment}
            className="w-full p-6 border-2 border-green-200 rounded-lg hover:border-green-400 hover:bg-green-50 transition-all duration-200"
          >
            <div className="flex items-center justify-center space-x-3">
              <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center">
                <svg className="w-5 h-5 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                </svg>
              </div>
              <div className="text-left">
                <div className="font-semibold text-gray-800">효성CMS로 가입하기</div>
                <div className="text-sm text-gray-500">은행 자동이체 신청서 작성</div>
              </div>
            </div>
          </button>

          <div className="mt-6 p-4 bg-gray-50 rounded-lg">
            <div className="text-sm text-gray-600">
              <div className="font-medium mb-2">결제 방법 안내</div>
              <ul className="space-y-1 text-xs">
                <li>• <strong>카드 결제</strong>: 즉시 결제 및 정기결제 자동 등록</li>
                <li>• <strong>계좌이체(효성CMS 이용)</strong>: 신청서 작성 후 홈페이지에 반영까지 1-2일 소요</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}